






















































































































import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import GenericModal from '@/componentsReusable/genericModal.vue';
import CheckboxControl from '@/componentsReusable/CheckboxControl.vue';
import {ChecklistItem, ChecklistTemplateSummary} from "@/interfaces/TaskInterfaces";
import {
  addTaskChecklistItem,
  createChecklistTemplate,
  deleteTaskChecklistItem, deleteTaskChecklistTemplate,
  updateTaskChecklistItem
} from "@/services/TaskService";
import genericModal from '@/componentsReusable/genericModal.vue'

export default Vue.component('task-checklist-control', {
  name: 'TaskChecklistControl',
  props: {
    items: { type: Array, required: true },
    taskId: { type: [Number, String], required: true }
  },
  data () {
    return {
      ourItems: [] as ChecklistItem[],
      showDropdown: false,
      showConfirmationModal: false,
      showTemplateConfirmationModal: false,
      newItemTitle: '',
      loading: false,
      pendingRemoveItem: null as any,
      pendingRemoveTemplate: null as any,
      showTemplateModal: false,
      templateName: '',
      visibleTo: 0,
      roles: [] as any,
      showErrorModal: false
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    GenericModal,
    CheckboxControl,
    genericModal
  },
  watch: {
    items(newItems: ChecklistItem[]) {
      this.ourItems = newItems.map(item => Object.assign({ isEditing: false }, item)) as ChecklistItem[];
    }
  },
  computed: {
    templates(): ChecklistTemplateSummary[] {
      return this.$store.state.task.checklistTemplates;
    },
    appUserId(): number {
      return this.$store.state.user.appUserId;
    }
  },
  created() {
    this.ourItems = this.items.map(item => Object.assign({ isEditing: false }, item)) as ChecklistItem[];
    this.setRoles();
  },
  methods: {
    setRoles() {
      const roles = [{ id: 0, name: 'Only You' }];
      this.$store.state.user.roles.forEach((role: any) => {
        roles.push({ id: role.id, name: role.name.charAt(0) + role.name.substr(1).toLowerCase() });
      });
      this.roles = roles;
    },
    toggleDropdown () {
      this.showDropdown = !this.showDropdown;
    },
    itemSelected(item: ChecklistItem) {
      item.isEditing = !item.isEditing;
    },
    async noteBlur(item: ChecklistItem) {
      await this.updateTaskChecklistItem(item);
    },
    async removeItem(item: ChecklistItem, bypassDeleteConfirmation: boolean = false) {
      if (!bypassDeleteConfirmation) {
        this.showConfirmationModal = true;
        this.pendingRemoveItem = item;
        return;
      } else {
        this.pendingRemoveItem = null;
      }
      try {
        this.loading = true;
        await deleteTaskChecklistItem(Number(this.taskId), item.id);
        this.newItemTitle = '';
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: err.response && err.response.data ? err.response.data.message : 'Failed to insert Checklist Item.'
        });
      }
      this.loading = false;
    },
    async removeConfirmed () {
      this.showConfirmationModal = false;
      await this.removeItem(this.pendingRemoveItem, true);
    },
    async addItem() {
      if (!this.newItemTitle) {
        return;
      }
      await this.createChecklistItems({ title: this.newItemTitle });
    },
    async createChecklistItems(data: { title?: string, templateId?: number }): Promise<void> {
      try {
        this.loading = true;
        await addTaskChecklistItem(Number(this.taskId), data);
        this.newItemTitle = '';
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: err.response && err.response.data ? err.response.data.message : 'Failed to insert Checklist Item(s).'
        });
      }
      this.loading = false;
    },
    async updateTaskChecklistItem(item: ChecklistItem): Promise<boolean> {
      let success = false;
      try {
        this.loading = true;
        await updateTaskChecklistItem(Number(this.taskId), item);
        success = true;
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: err.response && err.response.data ? err.response.data.message : 'Failed to update Checklist Item.'
        });
      }
      this.loading = false;
      return success;
    },
    async toggle(item: ChecklistItem) {
      if (!await this.updateTaskChecklistItem(item)) {
        item.isComplete = !item.isComplete;
      }
    },
    addTemplate() {
      if (this.items.length === 0) {
        this.showErrorModal = true;
        return;
      }
      this.showTemplateModal = true;
    },
    async saveTemplate() {
      if (!this.templateName || this.visibleTo < 0) {
        return;
      }
      try {
        this.loading = true;
        await createChecklistTemplate(Number(this.taskId), this.templateName, this.visibleTo);
        this.cancelTemplate();
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: err.response && err.response.data ? err.response.data.message : 'Failed to create Checklist Template.'
        });
      }
      this.loading = false;
    },
    cancelTemplate() {
      this.templateName = '';
      this.visibleTo = 0;
      this.showTemplateModal = false;
    },
    async templateSelected(template: ChecklistTemplateSummary) {
      await this.createChecklistItems({ templateId: template.id });
      this.showDropdown = false;
    },
    async removeTemplate(template: ChecklistTemplateSummary, bypassDeleteConfirmation: boolean = false) {
      if (!bypassDeleteConfirmation) {
        this.showTemplateConfirmationModal = true;
        this.pendingRemoveTemplate = template;
        return;
      } else {
        this.pendingRemoveTemplate = null;
      }
      try {
        this.loading = true;
        await deleteTaskChecklistTemplate(template.id);
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: err.response && err.response.data ? err.response.data.message : 'Failed to insert Checklist Item.'
        });
      }
      this.loading = false;
    },
    async removeTemplateConfirmed() {
      this.showTemplateConfirmationModal = false;
      await this.removeTemplate(this.pendingRemoveTemplate, true);
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/tasks/TaskChecklistControl.vue